import React from 'react';
import './SearchBar.css';

/**
 * Composant réutilisable pour les barres de recherche
 * @param {string} placeholder - Texte du placeholder
 * @param {string} value - Valeur contrôlée de l'input
 * @param {function} onChange - Fonction appelée lors du changement de valeur
 * @param {string} variant - Variante d'affichage ("default" ou "compact")
 * @param {string|ReactNode} icon - Icône personnalisée (défaut: "🔍")
 * @param {string} className - Classes CSS supplémentaires
 * @param {string} ariaLabel - Label d'accessibilité pour l'input
 * @param {string} maxWidth - Largeur maximale (défaut: "1000px" pour variant="default")
 */
const SearchBar = ({
  placeholder,
  value,
  onChange,
  variant = 'default',
  icon = '🔍',
  className = '',
  ariaLabel,
  maxWidth,
}) => {
  const containerClass = `search-bar search-bar-${variant} ${className}`.trim();
  const style = variant === 'default' && maxWidth ? { maxWidth } : {};

  if (variant === 'compact') {
    return (
      <div className={containerClass} style={style}>
        <span className="search-bar-icon">{icon}</span>
        <input
          type="text"
          className="search-bar-input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          aria-label={ariaLabel || placeholder}
        />
      </div>
    );
  }

  // Variant "default"
  return (
    <div className={containerClass} style={style}>
      <span className="search-bar-icon">{icon}</span>
      <input
        type="text"
        className="search-bar-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        aria-label={ariaLabel || placeholder}
      />
    </div>
  );
};

export default SearchBar;

